export default __webpack_public_path__ + "a308e27fb1621606e07351ac7222e87d.png";